import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { $routeParams } from '../services/ajs-upgraded-providers';
import * as deepEqual from 'deep-equal';
import * as moment from 'moment';
import { FlexmonsterPivot } from 'ng-flexmonster';
import * as Flexmonster from 'flexmonster';
import { Pivot } from "../shared/models/previewBalance/pivot.model";
import { Tab } from "../shared/models/previewBalance/tab.model";
import { Report } from "../shared/models/previewBalance/report.model";
import { PreviewBalanceConstants, SaveAction } from "../shared/constants/previewBalance.constants";
import { PreviewScheduleService } from "../services/preview-schedule.service";
import { UserInfoService } from "../main/objects/user-info.service";
import { Ng2ConfirmationService } from "../services/ng2confirmation.service";
import { ConstantsService } from '../services/constants.service';
import { FlashService } from "../services/flash.service";
import { ModalService } from "../services/modal.service";
import { SaveModalComponent } from "./save-modal/save-modal.component";
import { customizeCellFunction } from "./cell.customizer";

@Component({
    selector: 'app-previewBalance',
    templateUrl: './previewBalance.component.html',
    styleUrls: ['./previewBalance.component.scss']
})
export class PreviewBalanceComponent implements OnInit {

    customizeCellFunction: Function;
    @ViewChild('pivot', { static: false }) pivot: FlexmonsterPivot;
    dataLoaded: boolean = true;
    title: string = PreviewBalanceConstants.pageTitle;
    global: any = PreviewBalanceConstants.global;
    tabs: Tab[] = new Array<Tab>();
    selectedTab: Tab;
    reports: Report[] = new Array<Report>();
    originalReports: Report[] = new Array<Report>();
    defaultReports: Report[] = new Array<Report>();
    playgroundReport: Report = new Report();
    data: any = [];
    nameFilter: string = '';
    userFilter: string = '';
    licenceKey: string = '';
    currentUser: any = '';
    sortField: string = 'Name';
    sortOrder: boolean = true;
    alerts: any = {};

    constructor(
        private previewSchedule: PreviewScheduleService,
        private userInfo: UserInfoService,
        private confirmation: Ng2ConfirmationService,
        private constants: ConstantsService,
        private modalService: ModalService,
        private flashService: FlashService,
        private routeParams: $routeParams) { }

    ngOnInit() {
        this.dataLoaded = true;
        this.tabs.push(PreviewBalanceConstants.defaultTab);
        this.selectedTab = this.tabs[0];
        this.load();
        this.customizeCellFunction = customizeCellFunction;
    }

    public performFiltering() {

        this.reports = this.originalReports.filter(item => {
            return (item.reportName && item.reportName.toLowerCase().indexOf(this.nameFilter.toLowerCase()) !== -1) && (item.createdUserName.toLowerCase().indexOf(this.userFilter.toLowerCase()) !== -1);
        });

        this.reports.sort((a, b) => {
            switch (this.sortField) {
                case 'Date': {
                    if (this.sortOrder) {
                        return +moment(a.lastUpdatedDate, 'MM/DD/YYYY').format('YYYYMMDD') - +moment(b.lastUpdatedDate, 'MM/DD/YYYY').format('YYYYMMDD');
                    } else {
                        return +moment(b.lastUpdatedDate, 'MM/DD/YYYY').format('YYYYMMDD') - +moment(a.lastUpdatedDate, 'MM/DD/YYYY').format('YYYYMMDD');
                    }
                }
                case 'Name': {
                    if (this.sortOrder) {
                        return (a.reportName.toLowerCase() > b.reportName.toLowerCase()) ? 1 : (a.reportName.toLowerCase() < b.reportName.toLowerCase() ? -1 : 0);
                    } else {
                        return (a.reportName.toLowerCase() < b.reportName.toLowerCase()) ? 1 : (a.reportName.toLowerCase() > b.reportName.toLowerCase() ? -1 : 0);
                    }
                }
                case 'User': {
                    if (this.sortOrder) {
                        return (a.createdUserName.toLowerCase() > b.createdUserName.toLowerCase()) ? 1 : (a.createdUserName.toLowerCase() < b.createdUserName.toLowerCase() ? -1 : 0);
                    } else {
                        return (a.createdUserName.toLowerCase() < b.createdUserName.toLowerCase()) ? 1 : (a.createdUserName.toLowerCase() > b.createdUserName.toLowerCase() ? -1 : 0);
                    }
                }
                default:
                    return 0;
            }
        });

    }

    public sortBy(field: string) {
        if (this.sortField === field) {
            this.sortOrder = !this.sortOrder;
        }
        else {
            this.sortField = field;
        }
        this.performFiltering();
    }

    public openTab(tab) {
        if (this.selectedTab !== tab) {
            this.selectedTab = tab;
            if (this.pivot) {
                this.pivot.flexmonster.setReport(this.selectedTab.pivot);
            }
        }
    }

    private createTab(report: Report): Tab {
        let tab = new Tab(report.reportName, report.reportId, report.isPlayground ? 'playground' : 'report');
        tab.pivot = report.reportConfig;
        tab.originalPivot = Object.create(tab.pivot);
        tab.pivot.dataSource = { data: this.data };

        if(tab.type === 'playground'){
            tab.pivot.tableSizes = { "columns": [{ "idx": 0, "width": 400 }] };
        }
        
        return tab;
    }

    private createNewTab(): Tab {
        let tab = new Tab('Untitled', -1, 'report');
        tab.pivot = new Pivot();
        tab.originalPivot = Object.create(tab.pivot);
        tab.pivot.dataSource.data = this.data;
        
        this.tabs.push(tab);

        return tab;
    }

    private updateTab(report: Report) {
        let tab = this.getOpenedReportTab(report);
        if (tab) {
            let position = this.tabs.indexOf(tab);
            tab = this.createTab(report);
            this.tabs.splice(position, 1, tab);
            if (this.selectedTab.id === tab.id) {
                this.selectedTab = tab;
            }
        }
    }

    private getPlaygroundName(reportName) {
        let indexes = this.originalReports.filter(r => r.isPlayground).map(r => {
            let fv = r.reportName.split(' ');
            return parseInt(r.reportName.split(' ').pop())
        });

        let sortedIndexes = indexes.sort(function (a, b) {
            return (+a) - (+b);
        });

        let lastIndex = sortedIndexes.pop()

        return reportName + ' ' + (isNaN(lastIndex) ? 1 : lastIndex + 1);
    }

    public addNewTab() {
        let tab = this.createNewTab();
        this.selectedTab = tab;
        if (this.pivot) {
            this.pivot.flexmonster.setReport(this.selectedTab.pivot);
        }
    }

    public openReport(report: Report) {
        let tab = this.getOpenedReportTab(report);
        if (!tab) {
            tab = this.createTab(report);
            this.tabs.push(tab);
        }

        if (report.isPlayground) {
            tab.type = 'playground';
        }

        this.selectedTab = tab;
    }

    public closeTab(tab) {
        if (!this.hasTabPendingChanges(tab)) {
            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.selectedTab = this.tabs[0];
        }
        else {
            this.confirmation.Confirmation('Save pending changes?', { no: 'No', yes: 'Yes', cancel: 'Cancel' })
                .No(() => {
                    this.tabs.splice(this.tabs.indexOf(tab), 1);
                    this.selectedTab = this.tabs[0];
                })
                .Yes(() => {
                    if (tab.id !== -1) {
                        this.saveReport().then(() => {
                            this.tabs.splice(this.tabs.indexOf(tab), 1);
                            this.selectedTab = this.tabs[0];
                        });
                    }
                    else {
                        this.saveNewReport().then(() => {
                            this.tabs.splice(this.tabs.indexOf(tab), 1);
                            this.selectedTab = this.tabs[0];
                        });
                    }
                })
                .Ask({ container: this.GetModalContainer() });
        }
    }

    getOpenedReportTab(report: Report): Tab {
        if (report.isPlayground && report.isShared) {
            this.createNewReport(this.getPlaygroundName(report.reportName), report.reportConfig, report.isPlayground);
        }

        return this.tabs.find(item => item.id === report.reportId);
    }

    public load() {

        this.dataLoaded = false;
        this.flashService.ShowProgressBar(this.constants.ProgressBarLoadingSpeed.Slow);
        var applicationOptionId = +this.routeParams['id'];
        this.originalReports = [];

        this.userInfo.GetUserInfo().then(user => {
            this.previewSchedule.GetPreviewReports(applicationOptionId).then(result => {
                this.title = result.data.pageTitle || PreviewBalanceConstants.pageTitle;
                this.licenceKey = result.data.licenceKey;

                result.data.reports.forEach(item => {
                    item.lastUpdatedDate = moment(item.lastUpdatedDate).format('MM/DD/YYYY');
                    item.reportConfig = JSON.parse(item.reportConfig);
                });

                this.originalReports = result.data.reports.filter(item => !item.isShared);
                this.defaultReports = result.data.reports.filter(item => item.isShared && !item.isPlayground).sort((a, b) => {
                    return (a.reportName.toLowerCase() > b.reportName.toLowerCase()) ? 1 : (a.reportName.toLowerCase() < b.reportName.toLowerCase() ? -1 : 0);
                });

                this.playgroundReport = result.data.reports.filter(item => item.isPlayground && item.isShared)[0];

                let requests = [];

                requests.push(this.previewSchedule.GetPivotData({ siteId: this.userInfo.userInfo.currentSite.id }));

                this.originalReports.filter(item => item.isPlayground).forEach(item => {
                    requests.push(
                        this.previewSchedule.StaffPlaygroundData(item.reportId).then(result => {
                            item.playgroundChanges = this.preparePivotData(result.data.newPreviewBalanceData);
                            return Promise.resolve();
                        })
                    );
                });

                Promise.all(requests).then(result => {

                    this.data = this.preparePivotData(result[0].data.previewData);
                    this.alerts = result[0].data.previewIssues;

                    this.tabs.forEach(tab => {
                        if (tab.type === 'report' || tab.type === 'playground') {
                            tab.pivot.dataSource = { data: this.data };
                        }
                    });

                    if (this.selectedTab.type === 'report' || this.selectedTab.type === 'playground') {
                        this.selectedTab.pivot.dataSource = { data: this.data };

                        if (this.pivot) {
                            this.pivot.flexmonster.setReport(this.selectedTab.pivot);
                        }
                    }

                    this.dataLoaded = true;
                    this.flashService.HideProgressBar();
                    this.currentUser = this.userInfo.userInfo;
                    this.performFiltering();
                });
            });
        });
    }

    public customizeToolbar(toolbar) {

        var tabs = toolbar.getTabs();

        toolbar.getTabs = () => {
            tabs[0] = {
                icon: '<img style="vertical-align: super;" src="assets/icons/e-remove.svg" width="35" height="35" />',
                id: "fm-tab-close",
                handler: () => {
                    this.closeTab(this.selectedTab);
                },
                title: "Close",
            };

            tabs[1] = {
                icon: toolbar.icons.save,
                handler: () => {
                    this.saveReport();
                },
                title: "Save",
            };

            tabs[2] = {
                icon: toolbar.icons.save,
                id: "fm-tab-save-as",
                handler: () => {
                    this.saveNewReport();
                },
                title: "Save as",
            };

            var formatItems = tabs.find(item => item.id === 'fm-tab-format').menu;

            formatItems.forEach(item => item.rightGroup = true);

            tabs[8] = formatItems.find(item => item.id === "fm-tab-format-cells");
            tabs.splice(9, 0, formatItems.find(item => item.id === "fm-tab-format-conditional"));

            return tabs;
        };
    }

    public hasTabPendingChanges(tab) {

        return (tab.type === "report") ? !deepEqual(tab.pivot.options, tab.originalPivot.options)
            || !deepEqual(tab.pivot.conditions, tab.originalPivot.conditions)
            || !deepEqual(tab.pivot.formats, tab.originalPivot.formats)
            || !deepEqual(tab.pivot.slice, tab.originalPivot.slice) || tab.id === -1 : false;
    }

    public getAlertsCount() {
        return this.alerts.roomIssues.length +
            this.alerts.locationIssues.length +
            this.alerts.staffAttendanceIssues.length +
            this.alerts.staffActivityIssues.length;
    }

    public getPlaygoundReportsCount() {
        return this.originalReports.filter(r => r.isPlayground).length;
    }

    public openPlaygroundDrafts() {
        this.originalReports.filter(r => r.isPlayground).forEach((playground) => {
            this.openReport(playground);
        });
    }

    public OpenAlertTab() {
        if (!this.tabs[1] || this.tabs[1].type !== 'alert') {
            this.tabs.splice(1, 0, PreviewBalanceConstants.alertTab);
        }
        this.selectedTab = this.tabs[1];
    }

    public saveReport() {

        let report = this.getOpenedTabReport();
        if (report) {
            report.reportConfig = JSON.parse(JSON.stringify(this.selectedTab.pivot));
            report.lastUpdatedDate = moment().format('MM/DD/YYYY');
            report.updatedUserId = this.currentUser.id;
            report.updatedUserName = this.currentUser.fullname;
            report.reportConfig.options.grid = Object.assign(report.reportConfig.options.grid || {}, { title: report.reportName });
            report.reportConfig.options.chart = Object.assign(report.reportConfig.options.chart || {}, { title: report.reportName });
            if (this.pivot && this.pivot.flexmonster) {
                this.pivot.flexmonster.setReport(report.reportConfig);
            }
            let loading = this.modalService.Loading({ container: this.GetModalContainer() });

            return this.previewSchedule.SavePreviewReport(this.getRequest(report, SaveAction.Update)).then((result) => {

                this.updateTab(report);

                loading.dismiss();
                this.modalService.Success(result.data.message, { container: this.GetModalContainer() });
            });

        } else {
            return this.saveNewReport();
        }
    }

    public getOpenedTabReport() {
        return this.originalReports.find(item => item.reportId === this.selectedTab.id);
    }

    public onPlaygroundApplied(data) {

        data.forEach(row => {
            let previewItem = this.data.find(item => item.PreviewItemId === row.PreviewItemId);
            if (previewItem) {
                previewItem['Staff ID'] = row['Staff ID'];
                previewItem['Staff'] = row['Staff'];
                previewItem['Assignment Priority'] = row['Assignment Priority'];
            }
        });

        this.originalReports = this.originalReports.filter(report => !report.isPlayground);
        this.tabs = this.tabs.filter(tab => tab.type !== 'playground');
        this.selectedTab = this.tabs[0];
        this.performFiltering();
    }

    private GetModalContainer() {

        return this.selectedTab.type === 'report' || this.selectedTab.type === 'playground' ? '.fm-ng-wrapper' : 'body';
    }

    private getRequest(report: Report, action: SaveAction) {

        let request = {
            action: action,
            reportId: report.reportId,
            reportName: report.reportName,
            isPlayground: report.isPlayground,
            reportConfig: report.reportConfig as any
        };

        if (request.reportConfig.dataSource) {
            delete request.reportConfig.dataSource.data;
        }
        request.reportConfig = JSON.stringify(report.reportConfig);

        return request;
    }

    private createNewReport(reportName, reportConfig = null, isPlayground = null) {
        let report = new Report();
        report.reportConfig = JSON.parse(JSON.stringify(reportConfig || this.selectedTab.pivot));
        report.createdUserId = this.currentUser.userId;
        report.createdUserName = this.currentUser.fullname;
        report.reportName = reportName;
        report.isPlayground = isPlayground;
        report.lastUpdatedDate = moment().format('MM/DD/YYYY');
        report.reportConfig.options.grid = Object.assign(report.reportConfig.options.grid || {}, { title: report.reportName });
        report.reportConfig.options.chart = Object.assign(report.reportConfig.options.chart || {}, { title: report.reportName });

        let loading = this.modalService.Loading({ container: this.GetModalContainer() });

        return this.previewSchedule.SavePreviewReport(this.getRequest(report, SaveAction.Insert)).then((result) => {

            report.reportId = result.data.reportId;
            this.selectedTab.id = report.reportId;
            this.originalReports.push(report);
            this.performFiltering();
            this.updateTab(report);

            if (this.pivot && this.pivot.flexmonster) {
                this.pivot.flexmonster.setReport(this.selectedTab.pivot);
            }

            loading.dismiss();
            this.modalService.Success(result.data.message, { container: this.GetModalContainer() });
        });
    }

    public saveNewReport() {

        let dialog = this.modalService.OpenModal(SaveModalComponent, { container: ".fm-ng-wrapper" });
        dialog.componentInstance.title = "Save as";
        dialog.componentInstance.name = this.selectedTab.name;
        dialog.componentInstance.originalName = dialog.componentInstance.name;

        return dialog.result.then(newName => {
            this.createNewReport(newName);
        });
    }

    public renameReport(report: Report) {
        let dialog = this.modalService.OpenModal(SaveModalComponent, { container: this.GetModalContainer() });
        dialog.componentInstance.title = "Rename";
        dialog.componentInstance.name = report.reportName;
        dialog.componentInstance.originalName = dialog.componentInstance.name;
        dialog.result.then(newName => {
            report.reportName = newName;
            report.lastUpdatedDate = moment().format('MM/DD/YYYY');
            report.updatedUserId = this.currentUser.id;
            report.updatedUserName = this.currentUser.fullname;
            report.reportConfig.options.grid = Object.assign(report.reportConfig.options.grid || {}, { title: report.reportName });
            report.reportConfig.options.chart = Object.assign(report.reportConfig.options.chart || {}, { title: report.reportName });

            let loading = this.modalService.Loading();

            this.previewSchedule.SavePreviewReport(this.getRequest(report, SaveAction.Update)).then((result) => {

                this.updateTab(report);

                loading.dismiss();
                this.modalService.Success(result.data.message);
            });
        });
    }

    public onDeleteOpenedDraft(report: Report) {
        let closeTabCallback = function () { this.closeTab(this.selectedTab) };

        this.deleteReport(report, closeTabCallback);
    }

    public deleteReport(report: Report, callback?) {

        this.confirmation.YesNoConfirmation('Are you sure you want to delete?', { no: 'Cancel', yes: 'Delete' })
            .Yes(() => {
                let loading = this.modalService.Loading({ container: this.GetModalContainer() });
                this.previewSchedule.SavePreviewReport({ action: SaveAction.Delete, reportId: report.reportId }).then((result) => {
                    this.originalReports.splice(this.originalReports.indexOf(report), 1);
                    let tab = this.getOpenedReportTab(report);
                    if (tab) {
                        this.tabs.splice(this.tabs.indexOf(tab), 1);
                        if (this.selectedTab === tab) {
                            this.selectedTab = this.tabs[0];
                        }
                    }
                    this.performFiltering();

                    if (callback) {
                        callback();
                    }

                    loading.dismiss();
                    this.modalService.Success(result.data.message, { container: this.GetModalContainer() });
                });
            })
            .Ask();
    }

    public onReportChanged() {
        this.selectedTab.pivot = this.pivot.flexmonster.getReport();
    }

    private preparePivotData(previewBalanceData) {

        let data = [];

        previewBalanceData.forEach(item => {
            if (item.ScheduleDates) {
                item.ScheduleDates.forEach(date => {
                    let activity = Object.assign({}, item);
                    activity.ScheduleDates = undefined;
                    data.push(Object.assign(date, activity));
                });
            }
            else {
                data.push(item);
            }
        });

        return data;
    }

}

